import React, { Component } from "react";
import Constants from "../Constants.js";
import Levels from "../Levels.js";

import MenuInnerTile from "./MenuInnerTile.js";
import MenuOuterTile from "./MenuOuterTile.js";



class Level extends Component {

    constructor(props) {
        super(props);

        this.state = {
            active: false,
        }

        this.getTiles = this.getTiles.bind(this);
        this.getBoundsAtPosition = this.getBoundsAtPosition.bind(this);

        this.wrapper = React.createRef();
    }

    // Get bounds at some position
    getBoundsAtPosition(i, j) {
        const level = Levels[this.props.level];
        const height = level.layout.length;
        const width = level.layout[0].length;

        if (
            i < 0 ||
            i >= height ||
            j < 0 ||
            j >= width ||
            level.layout[i][j] === 0
        ) {
            return 0;
        }
        return 1;
    }

    // Get tile elements
    getTiles() {

        const level = Levels[this.props.level];
        const height = level.layout.length;
        const width = level.layout[0].length;

        let tiles = [];
        let key = 0;
        for (let i = 0; i < height; i++) {
            for (let j = 0; j < width; j++) {
                // Directly adjacent
                const top = this.getBoundsAtPosition(i - 1, j);
                const right = this.getBoundsAtPosition(i, j + 1);
                const bottom = this.getBoundsAtPosition(i + 1, j);
                const left = this.getBoundsAtPosition(i, j - 1);

                // Diagonal
                const topLeft = this.getBoundsAtPosition(i - 1, j - 1);
                const topRight = this.getBoundsAtPosition(i - 1, j + 1);
                const bottomRight = this.getBoundsAtPosition(i + 1, j + 1);
                const bottomLeft = this.getBoundsAtPosition(i + 1, j - 1);

                // This is an inner tile
                if (this.getBoundsAtPosition(i, j)) {
                    const topLeftRounded = !top && !left;
                    const topRightRounded = !top && !right;
                    const bottomRightRounded = !bottom && !right;
                    const bottomLeftRounded = !bottom && !left;

                    tiles.push(
                        <MenuInnerTile
                            key={"tile" + key}
                            topLeftRounded={topLeftRounded}
                            topRightRounded={topRightRounded}
                            bottomRightRounded={bottomRightRounded}
                            bottomLeftRounded={bottomLeftRounded}
                            row={i}
                            col={j}
                            innerColor={(this.props.unlocked ? level.colors.secondary : Constants.menuLockedColor)}
                            outerColor={(this.props.unlocked ? level.colors.primary : '#fff')}
                            unlocked={this.props.unlocked}
                        />
                    );
                }
                // This is an outer tile
                else {
                    const topLeftRounded = top && left && topLeft;
                    const topRightRounded = top && right && topRight;
                    const bottomRightRounded = bottom && right && bottomRight;
                    const bottomLeftRounded = bottom && left && bottomLeft;

                    tiles.push(
                        <MenuOuterTile
                            key={"tile" + key}
                            topLeftRounded={topLeftRounded}
                            topRightRounded={topRightRounded}
                            bottomRightRounded={bottomRightRounded}
                            bottomLeftRounded={bottomLeftRounded}
                            row={i}
                            col={j}
                            innerColor={(this.props.unlocked ? level.colors.secondary : Constants.menuLockedColor)}
                            outerColor={(this.props.unlocked ? level.colors.primary : '#fff')}
                            unlocked={this.props.unlocked}
                        />
                    );
                }

                key++;
            }
        }

        return tiles;
    }

    isInViewport() {
        let el = this.wrapper.current;
        let bounding = el.getBoundingClientRect();

        return (
            bounding.top + bounding.height >= 0 &&
            bounding.left + bounding.width >= 0 &&
            bounding.bottom - bounding.height <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right - bounding.width <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

/*
    componentDidMount() {
        this.setState({ inViewport: this.isInViewport() });
    }
    shouldComponentUpdate() {
        return this.state.inViewport !== this.isInViewport();
    }
    componentDidUpdate() {
        this.setState({ inViewport: this.isInViewport() });
    }
*/


    render() {

        const level = Levels[this.props.level];
        const height = level.layout.length;
        const width = level.layout[0].length;
        const theme = level.theme;

        return (
            <div
                ref={this.wrapper}
                style={{
                    position: 'relative',
                    overflow: 'hidden',
                    width: Constants.menuLevelSize + 'px',
                    height: Constants.menuLevelSize + 'px',
                    backgroundColor: (this.props.unlocked ? level.colors.primary : '#fff'),
                    margin: '8px 8px 8px 8px',
                    borderRadius: Constants.menuBorderRadius + 'px',
                    transform: 'scale(' + (this.state.active ? '0.9' : '1.0') + ') translateY(' + (this.props.unlocked ? '0' : '3px') + ')',
                    willChange: 'transform, box-shadow',
                    transition: 'transform 100ms, box-shadow 100ms',
                    display: 'inline-block',
                    boxSizing: 'border-box',
                    cusor: 'pointer',
                    border: (this.props.unlocked ? 'none' : '1px solid ' + Constants.menuLockedColor),
                    boxShadow: (this.props.unlocked ? '0 3px 0 ' + level.colors.secondary + ', 0 3px 5px rgba(0,0,0,0.15)' : 'none'),
                    //boxShadow: '0 2px 0 #dfe6e9, 0 2px 4px rgba(0,0,0,0.05)',
                }}
                onTouchStart={() => {
                    this.setState({active: true});
                }}
                onMouseDown={() => {
                    this.setState({active: true});
                }}
                onTouchEnd={() => {
                    this.setState({active: false});
                }}
                onMouseUp={() => {
                    this.setState({active: false});
                }}
                onMouseLeave={() => {
                    this.setState({active: false});
                }}
                onClick={() => {
                    if (this.props.unlocked) {
                        // if (window.TapticEngine) window.TapticEngine.impact({ style: "medium" });
                        this.props.onLevelSelect(this.props.level);
                    }
                }}
            >
                {
                    <div style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                    }}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                lineHeight: '1.0',
                                padding: '5px 15px 5px 15px',
                                backgroundColor: (this.props.unlocked ? level.colors.secondary : Constants.menuLockedColor),
                                borderBottom: '1px solid ' + (this.props.unlocked ? level.colors.primary : '#fff'),
                                borderRight: '1px solid ' + (this.props.unlocked ? level.colors.primary : '#fff'),
                                borderRadius: (Constants.menuBorderRadius - (this.props.unlocked ? 0 : 1)) + 'px 0 ' + Constants.menuBorderRadius + 'px 0',
                                fontSize: '16px',
                                fontWeight: '300',
                                zIndex: '3',
                                color: '#fff',
                            }}
                        >
                            {this.props.level + 1}
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                overflow: 'hidden',
                                width: Constants.menuLevelSize + 'px',
                                height: Constants.menuLevelSize + 'px',
                                borderRadius: Constants.menuBorderRadius + 'px',
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    overflow: 'hidden',
                                    width: (Constants.menuTileSize * width) + 'px',
                                    height: (Constants.menuTileSize * height) + 'px',
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translate(-50%,-50%) scale(' + (this.props.unlocked ? '1.0' : '1.0') + ') rotate(' + 0 + 'deg)',
                                    backgroundColor: (this.props.unlocked ? level.colors.primary : '#fff'),
                                }}
                            >
                                {this.getTiles()}
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                width: '100%',
                                textAlign: 'center',
                                bottom: '4px',
                                fontSize: '16px',
                                textTransform: 'lowercase',
                                color: '#fff',
                                padding: '0 4px',
                                boxSizing: 'border-box',
                                //color: (this.props.unlocked ? '#b2bec3' : '#E6E7E8'),
                            }}
                        >
                            {(this.props.unlocked ? theme : '')}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default Level;
